import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getCarImagesQueryOptions } from "./get-car-images";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";
import type { Attachment } from "@/types/attachment";

export const uploadCarImage = async ({ carId, file }: { carId: string; file: File }) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post(`/carburate/files/cars/images/${carId}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }) as Promise<Attachment>;
};

type UseUploadCarImageOptions = {
  mutationConfig?: MutationConfig<typeof uploadCarImage>;
};

export const useUploadCarImage = ({ mutationConfig }: UseUploadCarImageOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, { carId, ...args }, ...rest) => {
      queryClient.invalidateQueries({
        queryKey: getCarImagesQueryOptions(carId).queryKey,
      });
      onSuccess?.(data, { carId, ...args }, ...rest);
    },
    ...restConfig,
    mutationFn: uploadCarImage,
  });
};
